import React from "react";
import LegalLayout, {
  Section,
  Bullets,
  SupportLine,
} from "@/pages/LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout
      title="Terms of Service"
      lastUpdated="December 2025"
      testid="terms-page"
    >
      <Section heading="The Service">
        <p>
          CV AI PRO provides AI-assisted resume optimization. Depending on the
          plan you purchase, we may also deliver a custom cover letter,
          LinkedIn profile optimization, job-specific targeting, and related
          career deliverables. Final outputs are delivered as PDF and/or
          editable formats by email.
        </p>
      </Section>

      <Section heading="Delivery Times">
        <p>
          Standard delivery is within <span className="text-white">24 hours</span>{" "}
          of receiving your submission, unless we explicitly communicate a
          different timeframe. Priority plans (PRO and ELITE) are processed
          ahead of standard orders.
        </p>
        <p>
          Delays caused by missing information, unreadable uploads, or
          communication issues are outside our control and may extend delivery.
        </p>
      </Section>

      <Section heading="No Guarantee of Outcomes">
        <p>
          Purchasing a plan optimizes your resume — it does{" "}
          <span className="text-white">not</span> guarantee interviews, job
          offers, salary outcomes, or employment of any kind. Hiring decisions
          depend on factors outside our control, including market conditions,
          recruiter preferences, and your overall application.
        </p>
      </Section>

      <Section heading="Customer Responsibilities">
        <p>
          To enable us to deliver quality work, you agree to:
        </p>
        <Bullets
          items={[
            "Provide accurate, truthful, and up-to-date personal and career information",
            "Submit content you have the right to share (no copyrighted or third-party material)",
            "Respond promptly to our requests for clarification or missing details",
            "Use the final deliverables for your own job-seeking purposes",
          ]}
        />
        <p>
          Submitting fraudulent, misleading, or offensive content may result in
          cancellation of your order without refund.
        </p>
      </Section>

      <Section heading="Intellectual Property">
        <p>
          You retain ownership of your personal data and career history. Final
          deliverables (the optimized resume, cover letter, etc.) are licensed
          to you for personal job-seeking use. The underlying templates,
          engine, and methodology remain the property of CV AI PRO.
        </p>
      </Section>

      <Section heading="Revisions">
        <p>
          Each plan includes a defined revision policy (see the Pricing
          section). Additional revisions outside the included scope may incur a
          fee or be declined at our discretion.
        </p>
      </Section>

      <Section heading="Limitation of Liability">
        <p>
          The service is provided on an &quot;as is&quot; basis. To the maximum extent
          permitted by law, CV AI PRO is not liable for indirect, incidental,
          or consequential damages arising from the use of the service. Our
          total liability for any claim is limited to the amount you paid for
          the relevant order.
        </p>
      </Section>

      <Section heading="Changes to These Terms">
        <p>
          We may update these Terms from time to time. The &quot;Last updated&quot; date
          at the top reflects the current version. Continued use of the
          service after updates constitutes acceptance.
        </p>
      </Section>

      <Section heading="Contact">
        <SupportLine />
      </Section>
    </LegalLayout>
  );
}
